// Icons
import AITextGenerator from '../assets/icons/TextGenerator.vue';
import SentenceTemplates from '../assets/icons/SentenceTemplates.vue';
import ReferenceSearch from '../assets/icons/ReferenceSearch.vue';
import GrammarCheck from '../assets/icons/GrammarCheck.vue';
import JournalSelector from '../assets/icons/JournalSelector.vue';
import SentenceLength from '../assets/icons/SentenceLength.vue';
import CoverLetter from '../assets/icons/CoverLetter.vue';
import Paraphraser from '../assets/icons/Paraphraser.vue';
import PlagarismCheck from '../assets/icons/PlagarismCheck.vue';
import Summarizer from '../assets/icons/Summarizer.vue';
import DraftGenie from '../assets/icons/DraftGenie.vue';
import Reviewer from '../assets/icons/Reviewer.vue';

export const homeSideNavLinks = [];

export const extraSideNavLinks = [
  {
    title: 'Tutorials',
    url: '',
    icon: ''
  },
  {
    title: 'Support',
    url: '',
    icon: ''
  }
];

export const homeTopNavLinks = [
  {
    id: 'draft-genie-module',
    title: 'AI Paper Drafter',
    tooltip: 'Autogenerate a draft/outline using artificial intelligence.',
    url: '/home/draft-genie',
    icon: DraftGenie,
    featured: { active: true, text: 'Draft My Paper' },
    active: false
  },
  {
    id: 'ai-text-generation-module',
    title: 'Paper ChatGPT',
    tooltip: 'Autogenerate text using artificial intelligence.',
    url: '/home/text-generator',
    icon: AITextGenerator,
    featured: { active: true, text: 'Edit My Paper' },
    active: false
  },
  {
    id: 'reference-search-module',
    title: 'Bibliography Search',
    tooltip: 'Search for references.',
    url: '/home/sentence-templates',
    icon: ReferenceSearch,
    active: false
  },
  {
    id: 'reviewer-module',
    title: 'Peer Review',
    tooltip: 'Get in-depth feedback for each section',
    url: '/home/reviewer',
    icon: Reviewer,
    featured: { active: true, text: 'Get Peer Review' },
    active: false
  },
  {
    id: 'paraphraser-module',
    title: 'Paraphraser',
    tooltip: 'Paraphrase any part of your text.',
    url: '/home/paraphraser',
    icon: Paraphraser,
    active: false
  },
  {
    id: 'summarizer-module',
    title: 'Summarizer',
    tooltip: 'Summarize any part of your text.',
    url: '/home/summarizer',
    icon: Summarizer,
    active: false
  },
  {
    id: 'sentence-templates-module',
    title: 'Academic Phrasebank',
    tooltip: 'Insert thousands of template sentences.',
    url: '/home/sentence-templates',
    icon: SentenceTemplates,
    featured: { active: true, text: 'Use Academic Phrasebank' },
    active: false
  },
  {
    id: 'sentence-length-module',
    title: 'Sentence Length',
    tooltip: 'Detect complicated sentences.',
    url: '/home/sentence-length',
    icon: SentenceLength,
    active: false
  },
  {
    id: 'grammar-check-module',
    title: 'Grammar Check',
    tooltip: 'Check for grammar errors.',
    url: '/home/grammar-check',
    icon: GrammarCheck,
    active: false,
    // disabled: true,
  },
  {
    id: 'plagiarism-checker-module',
    title: 'Plagiarism Checker',
    tooltip: 'Check for plagiarism.',
    url: '/home/plagiarism-check',
    icon: PlagarismCheck,
    active: false
  },
  {
    id: 'cover-letter-module',
    title: 'Cover Letter',
    tooltip: 'Generate cover letters',
    url: '/home/text-generator',
    icon: CoverLetter,
    featured: { active: true, text: 'Write a Cover Letter' },
    active: false
  },
  {
    id: 'journal-selector-module',
    title: 'Journal Selector',
    tooltip: "Journal Selector'",
    url: '/home/text-generator',
    icon: JournalSelector,
    featured: { active: true, text: 'Select a Journal' },
    active: false
  }
  // {
  //   id: "transition-module",
  //   title: 'Transitions',
  //   tooltip: "Check for missing sentence transitions.",
  //   url: '/home/trasitions',
  //   icon: Transitions,
  //   active: false
  // },
  // {
  //   id: "paragraph-length-module",
  //   title: 'Paragraph Length',
  //   tooltip: "Detect paragraphs that are too long or short.",
  //   url: '/home/paragraph-length',
  //   icon: ParagraphLength,
  //   active: false
  // }
];
